// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import axios from "axios";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "@/assets/font/iconfont.css";
import echarts from "echarts";
import Moment from "moment";
import store from "./store";
import header from "./components/common/header";
import noData from "./components/common/noData";
import noContext from "./components/common/noContext";
import loading from "./components/common/loading";
import QzTabbar from "./components/common/QzTabbar/index";
import QzSearch from "./components/common/QzSearch/index";
import QzList from "./components/common/QzList/index";
import QzSplit from "./components/common/QzSplit/index";
import QzContent from "./components/common/QzContent/index";
Vue.component("QzTabbar", QzTabbar);
Vue.component("QzSearch", QzSearch);
Vue.component("QzList", QzList);
Vue.component("QzSplit", QzSplit);
Vue.component("QzContent", QzContent);
Vue.prototype.$echarts = echarts;
Vue.prototype.moment = Moment;
import Vant, { Toast } from "vant";
import "vant/lib/index.css";
Vue.use(Vant);
Vue.use(Toast);
Vue.use(ElementUI);
Vue.prototype.$axios = axios;
import jquery from "jquery";
Vue.prototype.$ = jquery;
window.$ = Vue.prototype.$;

Vue.config.productionTip = false;
Vue.component("Header", header);
Vue.component("NOdata", noData);
Vue.component("NOcontext", noContext);
Vue.component("qzLoading", loading);
import { GET_CONFIG } from "./utils/config";
import service from "./utils/request";
import VueResource from "vue-resource";
Vue.use(VueResource);
import VueAMap from "vue-amap";
import { lazyAMapApiLoaderInstance } from "vue-amap";
Vue.use(VueAMap);
window._AMapSecurityConfig={
  securityJsCode: window.__config__.VUE_AMAP_PASSWKEY,
};
VueAMap.initAMapApiLoader({
  key: window.__config__.VUE_AMAP_KEY,
  plugin: [
    "AMap.Autocomplete",
    //输入提示插件
    "AMap.PlaceSearch",
    //POI搜索插件
    "AMap.Scale",
    //右下角缩略图插件 比例尺
    "AMap.OverView",
    //地图鹰眼插件
    "AMap.ToolBar",
    //地图工具条
    "AMap.MapType",
    //类别切换控件，实现默认图层与卫星图、实施交通图层之间切换的控制
    "AMap.PolyEditor",
    //编辑 折线多，边形
    "AMap.CircleEditor",
    //圆形编辑器插件
    "AMap.Geolocation"
    //定位控件，用来获取和展示用户主机所在的经纬度位置
  ],
  v: "1.4.4",
  uiVersion: "1.0.11"
});
lazyAMapApiLoaderInstance.load().then(() => {
  // your code ...
  this.map = new AMap.Map("container", {
    resizeEnable: true
  });
});
Date.prototype.format = function(fmt) {
  var o = {
    "M+": this.getMonth() + 1, //月份
    "d+": this.getDate(), //日
    "h+": this.getHours(), //小时
    "m+": this.getMinutes(), //分
    "s+": this.getSeconds(), //秒
    "q+": Math.floor((this.getMonth() + 3) / 3), //季度
    S: this.getMilliseconds() //毫秒
  };
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(
      RegExp.$1,
      (this.getFullYear() + "").substr(4 - RegExp.$1.length)
    );
  }
  for (var k in o) {
    if (new RegExp("(" + k + ")").test(fmt)) {
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length)
      );
    }
  }
  return fmt;
};
//使用钩子函数对路由进行权限跳转
router.beforeEach(async (to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  let allowList = [
    "/login",
    "/",
    "/loginSso",
    "/casLogin",
    "/bindLogin",
    "/weChatLogin",
    "/thirdLogin",
    "/upload",
    "/uploadFile",
    "/test",
    "/student/attendance",
    "/retrievePwd",
    "/student/attendance_qzzyjsdx",
    "/bjgsdxLogin","/chooseTypeLogin"
  ];
  if (!sessionStorage.getItem("Token") && !allowList.includes(to.path)) {
    Toast("请先登录!");
    setTimeout(() => {
      next("/login");
    }, 1500);
  } else {
    if (process.env.NODE_ENV === "production") {
      let res = await GET_CONFIG();
      let rs = res.data;
      if (rs.schoolCode) {
        sessionStorage.setItem("schoolCode", rs.schoolCode);
        if (
          rs.schoolCode == "10534" ||
          rs.schoolCode == "12649" ||
          rs.schoolCode == "10555"
        ) {
          if (rs.forgetPwd) {
            sessionStorage.setItem("isWechat", rs.isWechat);
          }
          if (rs.forgetPwd) {
            sessionStorage.setItem("forgetPwd", rs.forgetPwd);
          }
          if (rs.release) {
            sessionStorage.setItem("release", rs.release);
          }
        }
      }
      //H5
      if (rs.ApiUrl && rs.SelectUrl) {
        sessionStorage.setItem("isConfig", 1);
        service.defaults.baseURL = rs.ApiUrl;
        sessionStorage.setItem("SelectUrl", rs.SelectUrl);
      }
      // 获取菜单url
      sessionStorage.setItem("ApiPro", rs.ApiPro);
      //上传
      if (rs.UploadUrl) {
        sessionStorage.setItem("uploadUrl", rs.UploadUrl);
      }
      //.net微信登录
      if (rs.weChatUrl) {
        sessionStorage.setItem("weChatUrl", rs.weChatUrl);
      }
    }
    // sessionStorage.setItem('schoolCode',"14360")
    next();
  }
});
/* eslint-disable no-new */
new Vue({
  el: "#app",
  store,
  router,
  components: {
    App
  },
  template: "<App/>",
});



// WEBPACK FOOTER //
// ./src/main.js